import {
  Button, InputNumber, Modal, Select, Space, Switch, Tabs,
} from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserCog } from '@fortawesome/free-solid-svg-icons/faUserCog';
import React, { ReactElement, useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../store/hooks';
import { setPmState } from '../store/entities/pm';
import { USE_DARK_MODE } from '../util/constants';
import { ChartHeightMode } from '../types/ChartHeightMode';

const { Option } = Select;
const { TabPane } = Tabs;

// const clusterMarkers = localStorage.getItem('clusterMarkers') === 'true'

const SettingsModal = (): ReactElement => {
  const dispatch = useAppDispatch();
  const clusterMarkers = useAppSelector((state) => state.entities.pm.clusterMarkers);
  const labelFontSize = useAppSelector((state) => state.entities.pm.labelFontSize);

  const chartHeightMode = useAppSelector((state) => state.entities.pm.chartHeightMode);
  const customChartHeight = useAppSelector((state) => (
    state.entities.pm.customChartHeight));
  const customYAxisGap = useAppSelector((state) => (
    state.entities.pm.customYAxisGap));

  const [isModalVisible, setIsModalVisible] = useState<boolean>(false);

  const setModalVisible = () => setIsModalVisible(true);
  const setModalInvisible = () => setIsModalVisible(false);

  useEffect(() => {
    localStorage.setItem('clusterMarkers', clusterMarkers ? 'true' : 'false');
    localStorage.setItem('chartHeightMode', chartHeightMode);
    localStorage.setItem('customChartHeight', `${customChartHeight}`);
    localStorage.setItem('customYAxisGap', `${customYAxisGap}`);
    localStorage.setItem('labelFontSize', `${labelFontSize}`);
  }, [clusterMarkers, customChartHeight, customYAxisGap, labelFontSize]);

  const onDarkModeChanged = (e: boolean) => {
    localStorage.setItem('darkMode', e ? 'true' : 'false');
    window.location.reload();
  };

  const onClusterMarkersChanged = (e: boolean) => dispatch(setPmState({ clusterMarkers: e }));

  // const onDynamicChartHeightChanged = (e: boolean) => (
  //   dispatch(setPmState({ dynamicChartHeight: e })));

  const onChartHeightModeChange = (value: ChartHeightMode) => (
    dispatch(setPmState({ chartHeightMode: value })));

  const onCustomChartHeightChange = (value: number) => (
    dispatch(setPmState({ customChartHeight: value })));

  const onCustomYAxisGapChange = (value: number) => (
    dispatch(setPmState({ customYAxisGap: value })));

  const onLabelFontSizeChange = (value: number) => dispatch(setPmState({ labelFontSize: value }));

  return (
    <div>
      <Button icon={<FontAwesomeIcon icon={faUserCog} />} onClick={setModalVisible} />
      <Modal
        title="Settings (auto-saved)"
        visible={isModalVisible}
        footer={null}
        onCancel={setModalInvisible}
      >
        <Tabs defaultActiveKey="general">
          <TabPane tab="General" key="general">
            <Space direction="vertical" style={{ width: '100%' }}>
              <Space>
                <Switch defaultChecked={USE_DARK_MODE} onChange={onDarkModeChanged} />
                Dark mode
              </Space>
              <Space>
                <Switch defaultChecked={clusterMarkers} onChange={onClusterMarkersChanged} />
                Cluster markers (faster)
              </Space>
            </Space>
          </TabPane>
          <TabPane tab="Chart Style" key="chart-style">
            <Space direction="vertical" style={{ width: '100%' }}>
              <Space>
                Chart height mode
                <Select<ChartHeightMode>
                  onChange={onChartHeightModeChange}
                  value={chartHeightMode}
                  style={{ width: '300px' }}
                >
                  <Option value="dynamic">Dynamic (show all intersection names)</Option>
                  <Option value="constant">Constant</Option>
                  <Option value="custom">Custom</Option>
                </Select>
                {/* <Switch defaultChecked={dynamicChartHeight} */}
                {/*        onChange={onDynamicChartHeightChanged} /> */}
                {/* Show all intersection names */}
              </Space>
              {chartHeightMode === 'custom'
          && (
            <>
              <Space>
                Chart Height
                <InputNumber
                  min={100}
                  max={1000}
                  step={10}
                  value={customChartHeight}
                  style={{ width: '75px' }}
                  onChange={onCustomChartHeightChange}
                />
                px
              </Space>
              <Space>
                Y Axis Left Margin
                <InputNumber
                  min={0}
                  max={500}
                  step={10}
                  value={customYAxisGap}
                  style={{ width: '75px' }}
                  onChange={onCustomYAxisGapChange}
                />
                px
              </Space>
            </>
          )}
              <Space>
                Label font size
                <InputNumber
                  min={0}
                  max={20}
                  step={1}
                  value={labelFontSize}
                  style={{ width: '75px' }}
                  onChange={onLabelFontSizeChange}
                />
                pt
              </Space>
            </Space>
          </TabPane>
        </Tabs>
      </Modal>
    </div>
  );
};

export default SettingsModal;
